import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-white" }
const _hoisted_2 = { class: "flex space-x-4 p-4" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "mega-menu pt-12 mb-16 sm:mb-0 shadow-xl" }
const _hoisted_5 = { class: "w-full bg-gray-900 p-6" }
const _hoisted_6 = { class: "container mx-auto w-full flex flex-wrap justify-between mx-2" }
const _hoisted_7 = { class: "w-full text-white mb-8" }
const _hoisted_8 = { class: "font-bold text-2xl" }
const _hoisted_9 = { class: "px-4 w-full sm:w-1/2 lg:w-1/4 border-gray-600 border-b sm:border-r lg:border-b-0 pb-6 pt-6 lg:pt-3" }
const _hoisted_10 = { class: "px-4 w-full sm:w-1/2 lg:w-1/4 border-gray-600 border-b sm:border-r-0 lg:border-r lg:border-b-0 pb-6 pt-6 lg:pt-3" }
const _hoisted_11 = { class: "px-4 w-full sm:w-1/2 lg:w-1/2 pb-6 pt-6 lg:pt-3" }
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.navigation.categories, (category) => {
        return (_openBlock(), _createElementBlock("li", {
          key: category.name,
          class: "hoverable relative flex justify-center"
        }, [
          _createElementVNode("a", {
            href: '/' + category.type,
            class: "relative z-10 flex items-center justify-center text-sm font-medium text-white transition-colors duration-200 ease-out"
          }, _toDisplayString(category.name), 9, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h2", _hoisted_8, _toDisplayString(category.name), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("p", null, "Encuentra la claridad visual que necesitas con lentes diseñados para tu comodidad y estilo.", -1))
                ]),
                _createElementVNode("ul", _hoisted_9, [
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex items-center" }, [
                    _createElementVNode("svg", {
                      class: "h-8 mb-3 mr-3 fill-current text-white",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 20 20"
                    }, [
                      _createElementVNode("path", { d: "M3 6c0-1.1.9-2 2-2h8l4-4h2v16h-2l-4-4H5a2 2 0 0 1-2-2H1V6h2zm8 9v5H8l-1.67-5H5v-2h8v2h-2z" })
                    ]),
                    _createElementVNode("h3", { class: "font-bold text-xl text-white text-bold mb-2" }, "Categorias")
                  ], -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category?.subcategories, (item) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: item.name,
                      to: '/aaa',
                      class: "flex items-center text-sm font-medium text-white z-10"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex items-center py-3" }, [
                    _createElementVNode("svg", {
                      class: "h-6 pr-3 fill-current text-blue-300",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 20 20"
                    }, [
                      _createElementVNode("path", { d: "M20 10a10 10 0 1 1-20 0 10 10 0 0 1 20 0zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0zm-8 2H5V8h5V5l5 5-5 5v-3z" })
                    ]),
                    _createElementVNode("a", {
                      href: "#",
                      class: "text-white bold border-b-2 border-blue-300 hover:text-blue-300"
                    }, "Find out more...")
                  ], -1))
                ]),
                _createElementVNode("ul", _hoisted_10, [
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex items-center" }, [
                    _createElementVNode("svg", {
                      class: "h-8 mb-3 mr-3 fill-current text-white",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 20 20"
                    }, [
                      _createElementVNode("path", { d: "M4.13 12H4a2 2 0 1 0 1.8 1.11L7.86 10a2.03 2.03 0 0 0 .65-.07l1.55 1.55a2 2 0 1 0 3.72-.37L15.87 8H16a2 2 0 1 0-1.8-1.11L12.14 10a2.03 2.03 0 0 0-.65.07L9.93 8.52a2 2 0 1 0-3.72.37L4.13 12zM0 4c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4z" })
                    ]),
                    _createElementVNode("h3", { class: "font-bold text-xl text-white text-bold mb-2" }, "Formas")
                  ], -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.navigation.shapes, (item) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: item.name,
                      to: '/aaa',
                      class: "flex items-center text-sm font-medium text-white z-10"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex items-center py-3" }, [
                    _createElementVNode("svg", {
                      class: "h-6 pr-3 fill-current text-blue-300",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 20 20"
                    }, [
                      _createElementVNode("path", { d: "M20 10a10 10 0 1 1-20 0 10 10 0 0 1 20 0zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0zm-8 2H5V8h5V5l5 5-5 5v-3z" })
                    ]),
                    _createElementVNode("a", {
                      href: "#",
                      class: "text-white bold border-b-2 border-blue-300 hover:text-blue-300"
                    }, "Find out more...")
                  ], -1))
                ]),
                _createElementVNode("ul", _hoisted_11, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex items-center" }, [
                    _createElementVNode("svg", {
                      class: "h-8 mb-3 mr-3 fill-current text-white",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 20 20"
                    }, [
                      _createElementVNode("path", { d: "M2 4v14h14v-6l2-2v10H0V2h10L8 4H2zm10.3-.3l4 4L8 16H4v-4l8.3-8.3zm1.4-1.4L16 0l4 4-2.3 2.3-4-4z" })
                    ]),
                    _createElementVNode("h3", { class: "font-bold text-xl text-white text-bold mb-2" }, "Marcas")
                  ], -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.navigation.brands, (item) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: item.name,
                      to: '/aaa',
                      class: "flex items-center text-sm font-medium text-white z-10"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          class: "h-12",
                          src: $data.apiUrl+'/'+item.logo,
                          alt: ""
                        }, null, 8, _hoisted_12),
                        _createTextVNode(" " + _toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex items-center py-3" }, [
                    _createElementVNode("svg", {
                      class: "h-6 pr-3 fill-current text-blue-300",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 20 20"
                    }, [
                      _createElementVNode("path", { d: "M20 10a10 10 0 1 1-20 0 10 10 0 0 1 20 0zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0zm-8 2H5V8h5V5l5 5-5 5v-3z" })
                    ]),
                    _createElementVNode("a", {
                      href: "#",
                      class: "text-white bold border-b-2 border-blue-300 hover:text-blue-300"
                    }, "Find out more...")
                  ], -1))
                ])
              ])
            ])
          ])
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.navigation.pages, (page) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: page.name,
          to: page.href,
          class: "flex items-center text-sm font-medium text-white z-10"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(page.name), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ])
  ]))
}